import { render } from "./IcoListModel.vue?vue&type=template&id=231e9a3d&scoped=true"
import script from "./IcoListModel.vue?vue&type=script&lang=js"
export * from "./IcoListModel.vue?vue&type=script&lang=js"

import "./IcoListModel.vue?vue&type=style&index=0&id=231e9a3d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-231e9a3d"]])

export default __exports__